import moment from 'moment-timezone';

import { NumberUtils } from '@pk/powerkioskutils';
import { HelperService } from '../helper.service';
import { Note } from './note';

export class ViewAgentEngagementEventContract {
	public id: number;
	public agentEngagementEventId: number;
	public contractId: string;
	public termValue: number;
	public unpurchasedQuantity: number;
	public isComplete: boolean;
	public addDate: Date;
	public noteId: string;
	public contractNum: string;
	public holdoverDate: Date;
	public effectiveDate: Date;
	public expirationDate: Date;
	public annualUsage: number;
	public serviceTypeId: string;
	public latestAuctionCompleteDate: Date;
	public displayStatus: string;
	public units: string;
	public margin: number;
	public commissionSplitBufferMarginParent: number;
	public commissionSplitBufferMarginBrother: number;
	public matrixAgentBufferMargin: number;
	public bufferMargin: number;
	public previousContractExpirationDate: Date;
	public dbaName: string;
	public agentId: string;
	public agentName: string;
	public serviceTypeName: string;
	public rfqSessionEndDate2: Date;
	public rfqSessionIsOnHold: boolean;
	public stateCountryIsoCode: string;

	public notes: Note[];

	constructor(viewAgentEngagementEventContract: ViewAgentEngagementEventContract) {
		Object.assign(this, viewAgentEngagementEventContract);

		this.addDate = this.addDate ? new Date(moment(this.addDate).format('MMM DD, YYYY 00:00:00 a')) : this.addDate;
		this.holdoverDate = this.holdoverDate ? new Date(moment(this.holdoverDate).format('MMM DD, YYYY 00:00:00 a')) : this.holdoverDate;
		this.effectiveDate = this.effectiveDate ? new Date(moment(this.effectiveDate).format('MMM DD, YYYY 00:00:00 a')) : this.effectiveDate;
		this.expirationDate = this.expirationDate ? new Date(moment(this.expirationDate).format('MMM DD, YYYY 00:00:00 a')) : this.expirationDate;
		this.latestAuctionCompleteDate = this.latestAuctionCompleteDate
			? new Date(moment(this.latestAuctionCompleteDate).format('MMM DD, YYYY 00:00:00 a'))
			: this.latestAuctionCompleteDate;
		this.previousContractExpirationDate = this.previousContractExpirationDate
			? new Date(moment(this.previousContractExpirationDate).format('MMM DD, YYYY 00:00:00 a'))
			: this.previousContractExpirationDate;
		this.rfqSessionEndDate2 = this.rfqSessionEndDate2
			? new Date(moment(this.rfqSessionEndDate2).format('MMM DD, YYYY 00:00:00 a'))
			: this.rfqSessionEndDate2;
	}

	public getDisplayAnnualUsage(unit?: string): string {
		const annualUsage = NumberUtils.amountToUnits(this.annualUsage, unit);

		return Math.round(annualUsage).toString();
	}

	public getTotalMargin(
		includeBufferMargin = true,
		includeParentBrotherBufferMargin = false,
		includeMatrixAgentBufferMargin = false,
		unit?: string,
	): number {
		return HelperService.getTotalMargin(this, includeBufferMargin, includeParentBrotherBufferMargin, includeMatrixAgentBufferMargin, unit);
	}
}
